// SeoContext.tsx
import { createContext, useContext, useState, ReactNode } from "react";

type SeoContextType = {
  canonical: string;
  setCanonical: (url: string) => void;
};

const SeoContext = createContext<SeoContextType | undefined>(undefined);

export const SeoProvider = ({ children }: { children: ReactNode }) => {
  const [canonical, setCanonical] = useState("");

  return (
    <SeoContext.Provider value={{ canonical, setCanonical }}>
      {children}
    </SeoContext.Provider>
  );
};

export const useSeo = () => {
  const context = useContext(SeoContext);
  if (!context) {
    throw new Error("useSeo must be used within a SeoProvider");
  }
  return context;
};